import React, { useState,useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import './styles/App.css';
import M_Footer from './M_Footer';
import { Link } from 'react-router-dom';
import TopTitle from './Pc_TopTitle';
import axios from 'axios';
import queryString from 'query-string';
import Search_icon from './img/eva_search-outline.png'
import { instance } from './common';
import { ImageMap } from '@qiuz/react-image-map';
import all_map from './img/map/전지역.png';
import seoul_map from './img/map/서울.png';
import incheon_map from './img/map/인천.png';
import gyeonggi_map from './img/map/경기.png';
import gangwon_map from './img/map/강원.png';
import chungnam_map from './img/map/충남.png';
import chungbuk_map from './img/map/충북.png';
import saejong_map from './img/map/세종.png';
import dejeon_map from './img/map/대전.png';
import gyeongbuk_map from './img/map/경북.png';
import daeggu_map from './img/map/대구.png';
import ulsan_map from './img/map/울산.png';
import busan_map from './img/map/부산.png';
import gyeongnam_map from './img/map/경남.png';
import jeonbuk_map from './img/map/전북.png';
import jeonnam_map from './img/map/전남.png';
import gwangju_map from './img/map/광주.png';
import jaeju_map from './img/map/제주.png';

function addresssSearch() {
    const user = window.sessionStorage.result;
    const j_user = JSON.parse(user);

    const u_dealer_agency = j_user.u_dealer_agency;//user의 address2 정보
    console.log('u_dealer_agency : ', u_dealer_agency)
    return u_dealer_agency;
}

function LoadNearSigong({history}){

    const [data, setData] = useState([]);
    let obj = {ag_id:addresssSearch()}


    const session = JSON.parse(window.sessionStorage.result);
    const {u_id} = session;
    const [serviceCate, setCate] = useState('썬가드하이퍼이벤트');

    useEffect(() => {
        instance.post('/cart/checked',{u_id:u_id}).then(function(res){

            console.log('res.data.rows : ', res.data.rows);
            setCate(res.data.rows[0].s_cate);

        
        });
    },[])
 
    useEffect(() => {
        
        const fetchData = async () => {
            instance.post('/agency/id',obj).then(function(res){
                
                let obj2 = {lat:res.data[0].ag_lat,lng:res.data[0].ag_long,si_show:serviceCate}
                instance.post('/sigong/near2',obj2).then(function(res){
                    console.log('res1 : ', res)
                    setData(res.data);
                });
            });
        
        };
  
        fetchData();
  
      }, [serviceCate]);
    
    const goDetail = (e) => {
        const {id} = e.target.dataset;
        history.push('/storeinfo?si_id='+id);
    }
    const goCalendar = (e) => {
        const {id} = e.target.dataset;
        history.push('/capitalcalendar?si_id='+id);
    }

    return(
        <>
        {
            data.map(v => <div className="py-4 botBorder" key={v.si_id}>
            <span className="" data-id={v.si_id} onClick={goCalendar}>{v.si_name}</span>
            <span className="btn btn-primary btn-sm p rounded-pill float-right" data-id={v.si_id} onClick={goDetail}>상세보기</span>
        </div>)
        }
        </>
    )

}
function LoadRegion({isName,isRegion,onRegionClick}){
    const [data, setData] = useState([]);
    let obj = {si_area1:isName}
    console.log('obj : ', obj)
    useEffect(() => {
        
        const fetchData = async () => {
            instance.post('/sigong/si_area1',obj).then(function(res){
                
                setData(res.data);
            });
        
        };

        fetchData();

    }, [isName]);


    const wordBreak = {
        wordBreak:'keep-all',
        cursor:"pointer"
    }

    return (
        <>
        {
            data.map(v => 
                v.si_area2.length === 3 
                ? isRegion == v.si_area2
                    ?
                    <div key={v.si_area2} 
                        className="col-4 text-center font-weight-bold pointer dClick mb-3 pl-2 pr-2"
                        onClick={onRegionClick} 
                        data-name={v.si_area2}><div className="border findActive p-1" data-name={v.si_area2} style={wordBreak}>{v.si_area2}</div>
                    </div>
                    :
                    <div key={v.si_area2} 
                        className="col-4 text-center mb-3 font-weight-bold  dClick pl-2 pr-2"
                        onClick={onRegionClick} 
                        data-name={v.si_area2}><div className="border p-1" data-name={v.si_area2} style={wordBreak}>{v.si_area2}</div>
                    </div>
                :  <></>
            )
        }
        {
            data.map(v => 
                v.si_area2.length === 4 
                ? isRegion == v.si_area2
                    ?
                    <div key={v.si_area2} 
                        className="col-4 text-center font-weight-bold dClick mb-3 pl-2 pr-2"
                        onClick={onRegionClick} 
                        data-name={v.si_area2}><div className="border findActive p-1" data-name={v.si_area2} style={wordBreak}>{v.si_area2}</div>
                    </div>
                    :
                    <div key={v.si_area2} 
                        className="col-4 text-center mb-3 font-weight-bold dClick pl-2 pr-2"
                        onClick={onRegionClick} 
                        data-name={v.si_area2}><div className="border p-1" data-name={v.si_area2} style={wordBreak}>{v.si_area2}</div>
                    </div>
                :  <></>
            )
        }
        {
            data.map(v => 
                v.si_area2.length > 4 
                ? isRegion == v.si_area2
                    ?
                    <div key={v.si_area2} 
                        className="col-4 text-center font-weight-bold dClick mb-3 pl-2 pr-2"
                        onClick={onRegionClick} 
                        data-name={v.si_area2}><div className="border findActive p-1" data-name={v.si_area2} style={wordBreak}>{v.si_area2.split('').map((items,index) => index !== 3 ? items : ' ' + items )}</div>
                    </div>
                    :
                    <div key={v.si_area2} 
                        className="col-4 text-center mb-3 font-weight-bold dClick pl-2 pr-2"
                        onClick={onRegionClick} 
                        data-name={v.si_area2}><div className="border p-1" data-name={v.si_area2} style={wordBreak}>{v.si_area2.split('').map((items,index) => index !== 3 ? items : ' ' + items )}</div>
                    </div>
                :  <></>
            )
        }
        </>
    )
}

function FindSigong({isName,isRegion,keyword,history,serviceCate}){

    const [data, setData] = useState([]);
    
    let obj = {si_area1:isName,si_area2:isRegion,keyword:keyword,si_show:serviceCate}

    useEffect(() => {
        
        const fetchData = async () => {
            instance.post('/sigong/select2',obj).then(function(res){
                
                setData(res.data);
            });
        
        };

        fetchData();

    }, [isName,isRegion,keyword,serviceCate]);

    const goDetail = (e) => {
        const {id} = e.target.dataset;
        history.push('/storeinfo?si_id='+id);
    }

    const goCalendar = (e) => {
        const {id} = e.target.dataset;
        history.push('/capitalcalendar?si_id='+id);
    }
    return (
        <>
        <table className="table table-boldered text-center">
            <thead>
                <tr>
                    <th>지역</th>
                    <th>상호명</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
            {
                data.map(v => 
                    <tr key={v.si_id} className="py-4 mt-2 border-top-0">
                        <td  data-id={v.si_id} onClick={goCalendar}>{v.si_area1} {v.si_area2}</td>
                        <td  data-id={v.si_id} onClick={goCalendar}>{v.si_name}</td>
                        <td  data-id={v.si_id} onClick={goDetail}>
                            <span className="btn btn-primary btn-sm p rounded-pill float-right" data-id={v.si_id} onClick={goDetail}>상세보기</span>
                        </td>
                    </tr>
                )
            }
            </tbody>
            <tfoot></tfoot>
        </table>

        </>
    )
}


function Pc_FindShop({ history, location, match }) {

    const [isName, setIsName] = useState('');
    const [isRegion, setIsRegion] = useState('');
    const [keyword, setKeyword] = useState('');



    const query = queryString.parse(location.search);
    

    const session = JSON.parse(window.sessionStorage.result);
    const {u_id} = session;
    const [serviceCate, setCate] = useState('썬가드하이퍼이벤트');

    useEffect(() => {
        instance.post('/cart/checked',{u_id:u_id}).then(function(res){

            console.log('res.data.rows : ', res.data.rows);
            setCate(res.data.rows[0].s_cate);

        
        });
    },[]);


    const mgstyle = {
        marginBottom: "100px"
    };

    const mgstyle2 = {
        marginTop: "50px"
    };
    const goBack = () => {
        history.push('/cart')
        
    };
    const paddingStyle = {
        padding: "3px 0"
    };

    
    const onRegionClick = (e) => {
        const { name } = e.target.dataset;
        setIsRegion(name);
    }

    const searchdiv = {
        background:'#ECECEC',
        borderRadius:'15px',
        right:0,
        top:'-3px',
        position:'absolute',
        width: '125px',
        height: '23px'
    }

    const inputSearch = {
        background: '#ececec',
        height:'100%',
        borderRadius: '15px'
    }

    const searchIcon = {
        width: '16px',
        position:'absolute',
        right: '4px',
        top: '3px'
    }

    const sigongSearch = () => {
        setUrl(all_map);
        setIsName('');
        setIsRegion('');
        
    }

    const onKeyword = (e) => {
        const {value} = e.target;
        setKeyword(value);
    }

    const mapArea = [
        {
            "width": "8.481262327416173%",
            "height": "2.7576197387518144%",
            "left": "18.612001257300143%",
            "top": "20.537513987592412%",
            "url" : incheon_map,
            "name" : '인천'
        },
        {
            "width": "5.9171597633136095%",
            "height": "2.8301886792452833%",
            "left": "29.65736614881888%",
            "top": "20.464945047098944%",
            "url" : seoul_map,
            "name" : '서울'
        },
        {
            "width": "9.368836291913215%",
            "height": "3.991291727140784%",
            "left": "35.475906582743924%",
            "top": "24.528805714733195%",
            "url" : gyeonggi_map,
            "name" : '경기'
        },
        {
            "width": "7.6923076923076925%",
            "height": "3.991291727140784%",
            "left": "59.63764228294117%",
            "top": "18.360445772788346%",
            "url" : gangwon_map,
            "name" : '강원'
        },
        {
            "width": "6.31163708086785%",
            "height": "2.7576197387518144%",
            "left": "32.91180401864137%",
            "top": "40.42140368280286%",
            "url" : saejong_map,
            "name" : '세종'
        },
        {
            "width": "6.903353057199212%",
            "height": "2.6124818577648767%",
            "left": "23.04987107978535%",
            "top": "41.07452414724408%",
            "url" : chungnam_map,
            "name" : '충청남도'
        },
        {
            "width": "6.41025641025641%",
            "height": "2.8301886792452833%",
            "left": "43.26683360444018%",
            "top": "37.95405970602492%",
            "url" : chungbuk_map,
            "name" : '충청북도'
        },
        {
            "width": "6.607495069033531%",
            "height": "3.0478955007256894%",
            "left": "35.27866792396681%",
            "top": "45.79150527931956%",
            "url" : dejeon_map,
            "name" : '대전'
        },
        {
            "width": "7.297830374753452%",
            "height": "3.265602322206096%",
            "left": "65.94927936380903%",
            "top": "46.880039386721585%",
            "url" : gyeongbuk_map,
            "name" : '경상북도'
        },
        {
            "width": "7.001972386587771%",
            "height": "3.3381712626995643%",
            "left": "29.65736614881888%",
            "top": "56.7494164011475%",
            "url" : jeonbuk_map,
            "name" : '전라북도'
        },
        {
            "width": "5.9171597633136095%",
            "height": "2.6850507982583456%",
            "left": "60.52521624743821%",
            "top": "57.765381568056064%",
            "url" : daeggu_map,
            "name" : '대구'
        },
        {
            "width": "7.988165680473373%",
            "height": "3.483309143686502%",
            "left": "52.6356698963534%",
            "top": "65.96567184381803%",
            "url" : gyeongnam_map,
            "name" : '경상남도'
        },
        {
            "width": "6.31163708086785%",
            "height": "2.9753265602322205%",
            "left": "75.9098316320536%",
            "top": "63.93374151000091%",
            "url" : ulsan_map,
            "name" : '울산'
        },
        {
            "width": "7.396449704142012%",
            "height": "3.0478955007256894%",
            "left": "70.88024583323703%",
            "top": "70.39237721391963%",
            "url" : busan_map,
            "name" : '부산'
        },
        {
            "width": "6.903353057199212%",
            "height": "2.8301886792452833%",
            "left": "19.696813880574304%",
            "top": "68.79586052306331%",
            "url" : gwangju_map,
            "name" : '광주'
        },
        {
            "width": "6.508875739644971%",
            "height": "2.9753265602322205%",
            "left": "18.907859245465822%",
            "top": "75.47220304846245%",
            "url" : jeonnam_map,
            "name" : '전라남도'
        },
        {
            "width": "6.31163708086785%",
            "height": "3.1204644412191582%",
            "left": "26.205689620219275%",
            "top": "94.12242075528393%",
            "url" : jaeju_map,
            "name" : '제주'
        }
    ];


    const [mapUrl, setUrl] = useState(all_map);

    const onMapClick = (area, index) => {
        setUrl(area.url);
        setIsName(area.name);
        setIsRegion('');
        setKeyword('');
    }

    const custombtn = {
        background:'#2F79D9',
        color:'#fff',
        display:'inline-block',
        height:'100%',
        width:'100%',
        lineHeight:'25px'
    }



    return (
        <>
            <Container className="px-5" style={mgstyle}>
            <div className="indexTopTitle">시공지점 선택</div>


                <div>
                    {
                        serviceCate !== '썬가드하이퍼이벤트'
                        &&
                        <div className="wrapDaeri row">
                        
                            <div className="col-5">
                                <ImageMap
                                    className="usage-map"
                                    src={mapUrl}
                                    map={mapArea}
                                    onMapClick={onMapClick}
                                />
                            </div>
                                
                            <div className="col-7 pl-0 pr-0 mt-3">
                                <div className="mapHwakText">지도에서 원하는 지역을 클릭하시거나 검색창에 직접 입력하시면 원하시는 ABYS의 대리점을 확인할 수 있습니다.</div>
                                <div className="row p-0 mt-5">
                                <LoadRegion 
                                isName={isName}
                                isRegion={isRegion}
                                onRegionClick={onRegionClick}
                                />
                            </div>
                                <div className="col-12 text-right pl-0 pr-0" onClick={sigongSearch}>
                                <input 
                                    type="text" 
                                    className="col-7" 
                                    style={{border:'1px solid #C4C4C4', marginTop:'51px'}}
                                    value={keyword}
                                    onChange={onKeyword}
                                    /><span className="col-2 text-center ml-3 d-inline-block" style={custombtn}>검색</span>
                                </div>
                            </div>
                        </div>
                    }

                </div>
                <div className="mt-2" id="tSigongWrap">
                    <FindSigong 
                    isName={isName} 
                    isRegion={isRegion}
                    keyword={keyword}
                    history={history}
                    serviceCate={serviceCate}
                    />
                </div>
                <div className="float-right font-weight-bold text-muted mt-5" onClick={goBack}>뒤로가기</div>
            </Container>
        </>
    );
}

export default Pc_FindShop;
